<template>
  <view>
    <view
      class="single-service-item"
      wx:class="{{{
        'bxgp': item.type === 1,
        'tgwu': item.type === 2,
      }}}"
      wx:for="{{ rightsInfo }}"
      wx:key="title"
    >
      <view class="single-up">
        <view class="single-left">
          <view class="single-title">{{item.title}}</view>
          <view class="single-price">{{+(item.fee / 100).toFixed(2)}}元/份</view>
        </view>
        <view class="single-right">
          <image wx:if="{{item.type === 2 && item.type !== selectedType}}" class="suggest-text" src="https://ut-static.udache.com/webx/sfc/gCGiGAe_2xT7MJvASf3PL_suggest-icon.png" />
          <view
            class="single-select-box"
            wx:class="{{{
              'single-select-box-yes': item.type === selectedType,
            }}}"
            bindtap="selectService(item)"
          >
            <spring-icon
              h="18"
              w="18"
              color="#fff"
              name="checkbox-check-mark"
            />
          </view>
        </view>
      </view>
      <view class="single-down" bindtap="openRightsDescDrawer(item.type)">
        <view class=tip-wrap>
          <view 
            wx:for="{{ item.tips ?? [] }}"
            wx:key="tipItem"
            wx:for-item="tipItem"
            class="tip"
          >
            <spring-icon
              color="{{item.type === 1 ? '#338FFF' : '#773D16'}}"
              h="15"
              w="16"
              name="marketing-check-mark"
              externClass="check-icon"
            />
            <view class="text" style="color: {{ item.type === 1 ? '#666' : '#773D16' }}">
              {{ tipItem }}
            </view>
          </view>
        </view>
        <spring-icon
          h="16"
          w="8"
          color="{{item.type === 1 ? 'rgba(102, 102, 102, 0.8)' : 'rgba(119, 61, 22, 0.8)'}}"
          name="right-thin-arrow"
          externClass="single-down-arrow-icon"
        />
      </view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'
  
  createComponent({
    props: {},
    data() {
      return {}
    },
    computed: {
      ...store.mapState({
        selectSeatInfo: 'train.selectSeatInfo', // 选中的坐席数据
        selectRightInfo: 'train.selectRightInfo' // 选中的权益卡数据
      }),
      rightsInfo() { // 普通预定辅营商品
        return this.selectSeatInfo?.[0]?.service_info?.makeOrderServiceInfoList ?? []
      },
      selectedType() { // 1便携购票 2退改无忧 3普通预定
        return this.selectRightInfo[0]?.type
      }

    },
    methods: {
      ...store.mapMutations({
        setSelectRightInfo: 'train.setSelectRightInfo',
        setAddedServiceSource: 'makeOrder.setAddedServiceSource'
      }),
      // 选择辅营商品
      selectService(item) {
        this.triggerEvent('selectService', item)
      },
      openRightsDescDrawer(type) {
        this.triggerEvent('openRightsDescDrawer', type)
      }
    }
  })
</script>

<style scoped lang="stylus">
  @font-face
    font-family MFYuanHei
    src url('https://ut-static.udache.com/webx/sfc/zFeca_fdUIuxJfpXUFGY5_ZaoZiGongFangYuanHeiTi-2-Medium.otf')
  .single-service-item
    border-radius 8px
    background #FFFFFF
    margin-bottom 10px
    .single-up
      display flex
      justify-content space-between
      padding 14px 12px 0px
      margin-bottom 10px
      .single-left
        display flex
        align-items center
      .single-title
        font-family MFYuanHei
        flex-shrink 0
        font-size 15px
        font-weight normal
        -webkit-background-clip text!important
        -webkit-text-fill-color transparent!important
        background-clip text!important
      .single-price
        font-family PingFang SC
        font-size 11px
        font-weight normal
        line-height 24px
        letter-spacing 0px
        font-variation-settings "opsz" auto
        margin-left 6px
      .single-right
        display flex
        align-items center
        justify-content center
      .suggest-text
        position relative
        right -2px
        width 60px
        height 18px
      .single-select-box
          width 18px
          height 18px
          box-sizing: border-box;
          border-radius 5px
          border: 1px solid #FF6400;
          background #fff
          display flex
          align-items center
          justify-content center
      .single-select-box-yes
        background #FF6400
    .single-down
      position relative
      display flex
      padding 10px
      border-radius 0px 0px 8px 8px
      .tip-wrap
        display flex
        overflow-x auto
        .tip 
          display flex
          flex-shrink: 0;
          align-items center
          .text
            font-size 11px
            line-height 12px
            font-family PingFangSC-Regular
            font-weight 400
            margin-left 3px
            margin-right 8px
      .single-down-arrow-icon
        width 28px
        display flex
        align-items center
        justify-content center
  .bxgp
    .single-up
      .single-title
        background linear-gradient(108deg, #2B7DF7 30%, #82BAFF 120%)
      .single-price
        color #666
    .single-down
      background: linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 25%, rgba(255, 255, 255, 0) 84%, #FFFFFF 97%), linear-gradient(180deg, rgba(51, 143, 255, 0.1) 0%, rgba(51, 143, 255, 0) 100%);
  .tgwu
    .single-up
      .single-title
        background linear-gradient(108deg, #FF4000 30%, #FF6400 120%)
      .single-price
        color rgba(119, 61, 22, 0.9)
    .single-down
      background linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 32%, rgba(255, 255, 255, 0) 81%, #FFFFFF 100%), linear-gradient(180deg, #FCEFDD 7%, rgba(253, 244, 230, 0.25) 97%)

</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'spring-icon': '@didi/spring-icon',
    }
  }
</script>